export enum TipoLogin {
    CPF = 0,
    Email = 1,
    LoginFacebook = 2,
    LoginGoogle = 3
}
